/* Ankaufsrechner (sections/cb-ankauf.liquid). Rechnet nicht selbst: schickt die Angaben an
   https://api.cleverbikes.de/ankauf/angebot und zeigt nur den zurückgegebenen Betrag. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cb-ankauf]');
  if (!root) return;
  var API = (root.getAttribute('data-endpoint') || 'https://api.cleverbikes.de').replace(/\/$/, '') + '/ankauf';

  var form = root.querySelector('[data-ak-form]');
  var kontakt = root.querySelector('[data-ak-kontakt]');
  var ergebnis = root.querySelector('[data-ak-ergebnis]');
  var danke = root.querySelector('[data-ak-danke]');
  var card = root.querySelector('.cb-ak-card');
  var schritt = 1;
  var angebotId = null;

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function wert(name) {
    var el = form.elements[name];
    if (!el) return '';
    if (el instanceof RadioNodeList || (el.length && el[0] && el[0].type === 'radio')) return el.value || '';
    if (el.type === 'checkbox') return el.checked;
    return (el.value || '').trim();
  }
  function zahl(text) {
    var t = String(text || '').replace(/[\s€]|km|nm|wh/gi, '');
    if (!t) return null;
    if (t.indexOf(',') >= 0) t = t.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(t)) t = t.replace(/\./g, '');
    var z = parseFloat(t);
    return isNaN(z) ? NaN : z;
  }
  function euro(betrag) {
    return betrag.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  // ── Fehleranzeige ──────────────────────────────────────────
  var SCHRITT_VON_FELD = { marke: 1, modell: 1, radtyp: 1, uvp: 2, kaufdatum: 2, km: 2, zustand: 2, motor: 3, bosch_reihe: 3, akku_wh: 3, nm: 3, kriterien: 3, email: 4 };
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/;
  function fehler(feld, text, scope) {
    var box = $('[data-ak-err="' + feld + '"]', scope);
    if (box) box.textContent = text || '';
    var f = $('[data-ak-field="' + feld + '"]', scope);
    if (f) f.classList.toggle('is-fehler', !!text);
  }
  function fehlerLeeren(scope) {
    $$('[data-ak-err]', scope).forEach(function (e) { e.textContent = ''; });
    $$('.is-fehler', scope).forEach(function (e) { e.classList.remove('is-fehler'); });
  }
  function ersterFehlerZeigen(scope) {
    var f = $('.is-fehler', scope);
    if (!f) return;
    var ziel = f.querySelector('input, select, textarea');
    f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (ziel) setTimeout(function () { ziel.focus({ preventScroll: true }); }, 250);
  }

  // ── Schritte ───────────────────────────────────────────────
  var LETZTER_SCHRITT = 4;   // Schritt 4 = E-Mail (Pflicht, seit 22.10.2026)
  var MAX_ALTER_MONATE = 72;   // wie auf dem Server: Ankauf nur bis 6 Jahre nach dem Kauf
  function zeigeSchritt(n, scroll) {
    schritt = n;
    $$('[data-ak-step]').forEach(function (s) { s.hidden = Number(s.getAttribute('data-ak-step')) !== n; });
    $$('[data-ak-progress]').forEach(function (p) {
      var i = Number(p.getAttribute('data-ak-progress'));
      p.classList.toggle('is-active', i === n);
      p.classList.toggle('is-done', i < n);
    });
    if (scroll && card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var erstes = $('[data-ak-step="' + n + '"] input:not([type=radio]):not([type=checkbox]), [data-ak-step="' + n + '"] select');
    if (scroll && erstes && window.matchMedia('(hover: hover)').matches) erstes.focus({ preventScroll: true });
  }

  function kriterienOk() {
    return $$('input[name=kriterium]', form).every(function (c) { return c.checked; });
  }

  // ── Neupreis auffällig hoch? (nur nach oben, Server vergleicht mit unseren Rädern) ──
  var uvpHinweis = $('[data-ak-uvp-hinweis]');
  var uvpGeprueft = null;   // Neupreis, für den der Hinweis gerade gilt
  function zeigeUvpHinweis(referenz) {
    $('[data-ak-uvp-referenz]').textContent = euro(referenz).replace(',00 €', ' €');
    uvpHinweis.hidden = false;
    uvpGeprueft = zahl(wert('uvp'));
  }
  function versteckeUvpHinweis() {
    uvpHinweis.hidden = true;
    form.elements.uvp_bestaetigt.checked = false;
    uvpGeprueft = null;
  }
  function uvpPruefen() {
    var neupreis = zahl(wert('uvp'));
    if (!uvpHinweis.hidden && uvpGeprueft === neupreis) {
      if (form.elements.uvp_bestaetigt.checked) return Promise.resolve(true);
      fehler('uvp', 'Bitte bestätige den Neupreis oder korrigiere ihn.', form);
      ersterFehlerZeigen(form);
      return Promise.resolve(false);
    }
    return senden('/pruefen', { marke: wert('marke'), modell: wert('modell'), uvp: neupreis }).then(function (d) {
      if (!d.auffaellig) { versteckeUvpHinweis(); return true; }
      zeigeUvpHinweis(d.referenz);
      uvpHinweis.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }).catch(function () { return true; });   // Prüfung nicht erreichbar: nicht blockieren
  }

  var markenGewartet = false;
  function weiter() {
    if (schritt === 1 && !markenAuswahl.liste().length && !markenGewartet) {   // Markenliste einmal abwarten
      markenGewartet = true;
      markenAuswahl.holen().then(weiter);
      return;
    }
    if (!pruefeSchritt(schritt)) return;
    if (schritt === 2) {
      uvpPruefen().then(function (ok) { if (ok) zeigeSchritt(3, true); });
    } else if (schritt >= LETZTER_SCHRITT) berechnen();
    else zeigeSchritt(schritt + 1, true);
  }

  function boschAnpassen() {
    var bosch = wert('motor') === 'bosch';
    $$('[data-ak-bosch]').forEach(function (e) { e.hidden = !bosch; });
  }

  function pruefeSchritt(n) {
    fehlerLeeren(form);
    var ok = true;
    function f(feld, text) { fehler(feld, text, form); ok = false; }
    if (n === 1) {
      if (!wert('marke')) f('marke', 'Bitte wähle die Marke.');
      else if (!markeGueltig()) f('marke', 'Bitte wähle die Marke aus der Liste.');
      if (!wert('modell')) f('modell', 'Bitte gib das Modell an.');
      if (!wert('radtyp')) f('radtyp', 'Bitte wähle den Radtyp.');
    } else if (n === 2) {
      var uvp = zahl(wert('uvp'));
      if (uvp === null) f('uvp', 'Bitte gib den Neupreis an.');
      else if (isNaN(uvp) || uvp < 300 || uvp > 20000) f('uvp', 'Bitte gib den Neupreis zwischen 300 und 20.000 € an.');
      if (!wert('kauf_monat') || !wert('kauf_jahr')) f('kaufdatum', 'Bitte wähle Monat und Jahr.');
      else {
        var heute = new Date();
        var j = Number(wert('kauf_jahr')), m = Number(wert('kauf_monat'));
        var alter = (heute.getFullYear() - j) * 12 + (heute.getMonth() + 1 - m);
        if (alter < 0) f('kaufdatum', 'Das Kaufdatum liegt in der Zukunft.');
        else if (alter > MAX_ALTER_MONATE) f('kaufdatum', 'Wir kaufen E-Bikes bis 6 Jahre nach dem Kauf an. Für ältere können wir online leider kein Angebot machen.');
      }
      var km = zahl(wert('km'));
      if (km === null) f('km', 'Bitte gib den Kilometerstand an.');
      else if (km !== null && (isNaN(km) || km < 0 || km > 100000)) f('km', 'Bitte gib den Kilometerstand als Zahl an.');
      if (!wert('zustand')) f('zustand', 'Bitte wähle den Zustand.');
    } else if (n === 3) {
      if (!wert('motor')) f('motor', 'Bitte wähle den Motorhersteller.');
      if (wert('motor') === 'bosch' && !wert('bosch_reihe')) f('bosch_reihe', 'Bitte wähle den Bosch-Motor.');
      var nm = zahl(wert('nm'));
      if (nm !== null && (isNaN(nm) || nm < 10 || nm > 200)) f('nm', 'Bitte gib das Drehmoment zwischen 10 und 200 Nm an.');
      if (!kriterienOk()) f('kriterien', 'Bitte bestätige die drei Punkte. Trifft etwas nicht zu, schreib uns.');
    } else if (n === 4) {
      if (!wert('email')) f('email', 'Bitte gib deine E-Mail-Adresse an. Dorthin schicken wir dein Angebot.');
      else if (!EMAIL_RE.test(wert('email'))) f('email', 'Bitte prüf deine E-Mail-Adresse.');
    }
    if (!ok) ersterFehlerZeigen(form);
    return ok;
  }

  // ── Auswahllisten mit Suche (Marke: nur aus der Liste · Modell: Vorschläge, freie Eingabe erlaubt) ──
  function norm(s) { return String(s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); }
  function escape(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function auswahl(input, liste, laden, opts) {
    var eintraege = [], aktiv = -1, ladeFuer = null, ladung = null;
    function holen() {
      var schluessel = opts.schluessel ? opts.schluessel() : '';
      if (ladeFuer !== schluessel || !ladung) {
        ladeFuer = schluessel;
        ladung = laden(schluessel).then(function (l) { eintraege = l || []; }).catch(function () { eintraege = []; });
      }
      return ladung;
    }
    function zeigen() {
      var q = norm(input.value), start = [], drin = [];
      eintraege.forEach(function (n) {
        var k = norm(n);
        if (!q || k.indexOf(q) === 0) start.push(n); else if (q.length >= 2 && k.indexOf(q) > 0) drin.push(n);
      });
      var treffer = start.concat(drin).slice(0, opts.max || 60);
      aktiv = -1;
      if (!treffer.length) {
        liste.innerHTML = opts.leer ? '<li class="cb-ak-suggest__leer" role="presentation">' + opts.leer(input.value.trim()) + '</li>' : '';
        liste.hidden = !opts.leer || !input.value.trim();
      } else {
        var roh = input.value.trim().toLowerCase();
        liste.innerHTML = treffer.map(function (n, i) {
          var html = escape(n);
          if (roh && n.toLowerCase().indexOf(roh) === 0) html = '<mark>' + escape(n.slice(0, roh.length)) + '</mark>' + escape(n.slice(roh.length));
          return '<li role="option" id="' + liste.id + '-' + i + '" data-wert="' + escape(n) + '">' + html + '</li>';
        }).join('');
        liste.hidden = false;
      }
      input.setAttribute('aria-expanded', liste.hidden ? 'false' : 'true');
    }
    function schliessen() { liste.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
    function waehlen(wert) { input.value = wert; schliessen(); if (opts.gewaehlt) opts.gewaehlt(wert); }
    function markiere(i) {
      var li = $$('li[role=option]', liste);
      if (!li.length) return;
      aktiv = (i + li.length) % li.length;
      li.forEach(function (e, j) { e.setAttribute('aria-selected', j === aktiv ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', li[aktiv].id);
      li[aktiv].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('focus', function () { holen().then(zeigen); });
    input.addEventListener('click', function () { holen().then(zeigen); });
    input.addEventListener('input', function () { holen().then(zeigen); if (opts.getippt) opts.getippt(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (liste.hidden) holen().then(zeigen); else markiere(aktiv + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); markiere(aktiv - 1); }
      else if (e.key === 'Enter' && !liste.hidden && aktiv >= 0) { e.preventDefault(); waehlen($$('li[role=option]', liste)[aktiv].getAttribute('data-wert')); }
      else if (e.key === 'Escape') schliessen();
    });
    liste.addEventListener('mousedown', function (e) {
      var li = e.target.closest('li[role=option]');
      e.preventDefault();
      if (li) waehlen(li.getAttribute('data-wert'));
    });
    input.addEventListener('blur', function () { setTimeout(function () { schliessen(); if (opts.verlassen) opts.verlassen(); }, 120); });
    return { holen: holen, liste: function () { return eintraege; } };
  }

  // Marke: nur Einträge der Markenliste (die Liste kommt vom Server, ohne Kategorien)
  var mInput = $('#cb-ak-marke'), oInput = $('#cb-ak-modell');
  var markenAuswahl = auswahl(mInput, $('#cb-ak-marken'), function () {
    return fetch(API + '/marken').then(function (r) { return r.json(); }).then(function (d) { return d.marken; });
  }, {
    max: 700,
    leer: function (t) { return 'Keine Marke „' + escape(t) + '“ gefunden. <a href="mailto:kontakt@cleverbikes.de?subject=Ankauf%20meines%20E-Bikes">Schreib uns</a>'; },
    getippt: function () { fehler('marke', '', form); mInput.removeAttribute('data-ok'); },
    gewaehlt: function () { mInput.setAttribute('data-ok', '1'); fehler('marke', '', form); modellAuswahl.holen(); oInput.focus(); },
    verlassen: markePruefen
  });
  function markeGueltig() {
    if (!markenAuswahl.liste().length) return !!mInput.value.trim();   // Liste nicht ladbar: der Server prüft
    var t = norm(mInput.value);
    var treffer = markenAuswahl.liste().filter(function (n) { return norm(n) === t; })[0];
    if (treffer) mInput.value = treffer;   // Groß-/Kleinschreibung wie in der Liste
    return !!treffer;
  }
  function markePruefen() {
    if (!mInput.value.trim()) return false;
    var ok = markeGueltig();
    if (!ok) fehler('marke', 'Bitte wähle die Marke aus der Liste.', form);
    return ok;
  }

  // Modell: Modelle dieser Marke aus unseren verkauften Rädern, eigenes Modell erlaubt
  var modellAuswahl = auswahl(oInput, $('#cb-ak-modelle'), function (marke) {
    if (!marke) return Promise.resolve([]);
    return fetch(API + '/modelle?marke=' + encodeURIComponent(marke)).then(function (r) { return r.json(); }).then(function (d) { return d.modelle; });
  }, {
    max: 60,
    schluessel: function () { return markeGueltig() ? mInput.value : ''; },
    getippt: function () { fehler('modell', '', form); }
  });

  // ── Ereignisse Formular ────────────────────────────────────
  form.addEventListener('change', function (e) {
    var n = e.target.name;
    if (n === 'motor') boschAnpassen();
    if (n === 'kriterium') fehler('kriterien', '', form);
    if (n) fehler(n === 'kauf_monat' || n === 'kauf_jahr' ? 'kaufdatum' : n, '', form);
  });
  form.elements.uvp.addEventListener('input', function () {
    if (!uvpHinweis.hidden && zahl(wert('uvp')) !== uvpGeprueft) versteckeUvpHinweis();
  });
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'submit' && e.target !== mInput && e.target !== oInput) {
      e.preventDefault();
      weiter();
    }
  });
  $$('[data-ak-weiter]').forEach(function (b) {
    b.addEventListener('click', weiter);
  });
  $$('[data-ak-zurueck]').forEach(function (b) {
    b.addEventListener('click', function () { fehlerLeeren(form); zeigeSchritt(Number(b.getAttribute('data-ak-zurueck')), true); });
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (schritt < LETZTER_SCHRITT) weiter();
    else if (pruefeSchritt(schritt)) berechnen();
  });

  function senden(pfad, daten) {
    return fetch(API + pfad, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(daten) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) {
            var f = d.fehler || {};
            var err = new Error(f.meldung || 'Da ist etwas schiefgelaufen. Bitte versuche es erneut.');
            err.feld = f.feld;
            err.code = f.code;
            err.referenz = f.referenz;
            throw err;
          }
          return d;
        });
      });
  }

  function radname() {
    var m = wert('marke'), mo = wert('modell');
    return (m + ' ' + mo).trim();
  }

  function berechnen() {
    var km = zahl(wert('km'));
    var nm = zahl(wert('nm'));
    var daten = {
      marke: wert('marke'), modell: wert('modell'), antrieb: wert('antrieb'), radtyp: wert('radtyp'),
      uvp: zahl(wert('uvp')), kauf_monat: Number(wert('kauf_monat')), kauf_jahr: Number(wert('kauf_jahr')),
      km: km === null ? null : Math.round(km), zustand: wert('zustand'),
      motor: wert('motor'), bosch_reihe: wert('bosch_reihe') || null, smart: wert('smart') || 'unbekannt',
      akku_wh: wert('akku_wh') ? Number(wert('akku_wh')) : null, nm: nm === null ? null : Math.round(nm),
      kriterien: kriterienOk(), uvp_bestaetigt: form.elements.uvp_bestaetigt.checked,
      email: wert('email'), kontakt_ok: form.elements.kontakt_ok.checked
    };
    var knopf = $('[data-ak-step="' + schritt + '"] .cb-ak-btn--gross');
    var text = knopf ? knopf.textContent : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = 'Wird berechnet …'; }
    fehler('global', '', form);
    senden('/angebot', daten).then(function (d) {
      angebotId = d.id;
      zeigeErgebnis(d);
    }).catch(function (err) {
      if (err.code === 'uvp_hoch') {
        zeigeSchritt(2, true);
        zeigeUvpHinweis(err.referenz);
        uvpHinweis.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (err.feld && SCHRITT_VON_FELD[err.feld]) {
        zeigeSchritt(SCHRITT_VON_FELD[err.feld], true);
        fehler(err.feld, err.message, form);
        ersterFehlerZeigen(form);
      } else fehler('global', err.message, form);
    }).then(function () {
      if (knopf) { knopf.disabled = false; knopf.textContent = text; }
    });
  }

  function zeigeErgebnis(d, rad, email) {   // rad/email nur beim gespeicherten Angebot (Link aus der Mail)
    var angebot = d.angebot;
    var gespeichert = rad !== undefined;
    if (rad === undefined) rad = radname();
    if (email === undefined) email = wert('email');
    form.hidden = true;
    ergebnis.hidden = false;
    var mit = angebot !== null && angebot !== undefined;
    $('[data-ak-mit-angebot]').hidden = !mit;
    $('[data-ak-ohne-angebot]').hidden = mit;
    kontakt.hidden = !mit;
    if (mit) {
      $('[data-ak-radname]').textContent = rad;
      $('[data-ak-mail-an]').textContent = email;
      $('[data-ak-mail-hinweis]').hidden = gespeichert;   // die Mail hat der Kunde ja schon
      $('[data-ak-angaben]').hidden = true;
      if (!kontakt.elements.email.value) kontakt.elements.email.value = email;
      $('[data-ak-betrag]').textContent = euro(angebot);
      var plus = d.inzahlung ? d.inzahlung - angebot : 0;
      $('[data-ak-plus-box]').hidden = !(plus > 0);
      if (plus > 0) {
        $('[data-ak-inzahlung]').textContent = euro(d.inzahlung);
        $('[data-ak-bonus]').textContent = '(+' + euro(plus).replace(',00 €', ' €') + ')';
        $('[data-ak-wunsch-aus]').textContent = 'Auszahlung: ' + euro(angebot);
        $('[data-ak-wunsch-in]').textContent = 'Beim Kauf verrechnen: ' + euro(d.inzahlung);
      }
      $('[data-ak-field="wunsch"]', kontakt).hidden = !(plus > 0);
    }
    fehlerLeeren(kontakt);
    card.scrollIntoView({ behavior: gespeichert ? 'auto' : 'smooth', block: 'start' });
  }

  $$('[data-ak-aendern]').forEach(function (b) {
    b.addEventListener('click', function () {
      ergebnis.hidden = true;
      form.hidden = false;
      $('[data-ak-hinweis]').hidden = true;
      if (ausMail) linkEntfernen();   // gespeichertes Angebot verlassen: neu berechnen
      zeigeSchritt(1, true);
    });
  });

  // ── Link aus der Angebotsmail (?angebot=<id>, seit 29.10.2026) ──
  // Lädt das gespeicherte Angebot und springt direkt zu „Ankauf anfragen“, statt den Rechner noch einmal zu zeigen.
  var ausMail = false;
  function linkEntfernen() {
    ausMail = false;
    try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) { /* egal */ }
    $$('[data-ak-aendern]').forEach(function (b) { b.textContent = 'Angaben ändern'; });
  }
  function hinweis(text) {
    $('[data-ak-hinweis-text]').textContent = text;
    $('[data-ak-hinweis]').hidden = false;
  }
  function gespeichertesAngebot() {
    var id = (new URLSearchParams(location.search).get('angebot') || '').toLowerCase();
    if (!/^[0-9a-f]{24}$/.test(id)) return;
    var laden = $('[data-ak-laden]');
    form.hidden = true;
    laden.hidden = false;
    fetch(API + '/angebot/' + id).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (d) {
      laden.hidden = true;
      if (d.status === 'offen') {
        ausMail = true;
        angebotId = id;
        zeigeErgebnis(d, d.rad, d.email);
        var angaben = $('[data-ak-angaben]');
        angaben.textContent = 'Deine Angaben: ' + d.angaben + '. Anfragen bis ' + d.gueltig_bis + '.';
        angaben.hidden = false;
        $$('[data-ak-aendern]').forEach(function (b) { b.textContent = 'Neues Angebot berechnen'; });
        return;
      }
      if (d.status === 'angefragt') {   // schon angefragt: Danke-Ansicht mit Vorgangsnummer statt Rechner
        danke.hidden = false;
        $('[data-ak-vorgang]').textContent = d.anfrage || '';
        return;
      }
      form.hidden = false;
      linkEntfernen();
      if (d.status === 'abgelaufen') hinweis('Dein Angebot vom ' + d.vom + ' ist abgelaufen. Berechne es einfach neu, das dauert nur 2 Minuten.');
      else hinweis('Wir konnten dein Angebot nicht finden. Berechne es hier neu oder antworte einfach auf unsere Angebotsmail.');
    }).catch(function () {
      laden.hidden = true;
      form.hidden = false;
      hinweis('Dein Angebot konnte gerade nicht geladen werden. Versuch es gleich noch einmal oder antworte einfach auf unsere Angebotsmail.');
    });
  }

  // ── Angebot annehmen ───────────────────────────────────────
  kontakt.addEventListener('submit', function (e) {
    e.preventDefault();
    fehlerLeeren(kontakt);
    var el = kontakt.elements;
    var daten = {
      id: angebotId, vorname: el.vorname.value.trim(), nachname: el.nachname.value.trim(), email: el.email.value.trim(),
      telefon: el.telefon.value.trim(), plz: el.plz.value.trim(), ort: el.ort.value.trim(),
      nachricht: el.nachricht.value.trim(), datenschutz: el.datenschutz.checked,
      wunsch: (kontakt.querySelector('input[name=wunsch]:checked') || {}).value || ''
    };
    var ok = true;
    function f(feld, text) { fehler(feld, text, kontakt); ok = false; }
    var mitWunsch = !$('[data-ak-field="wunsch"]', kontakt).hidden;
    if (!mitWunsch) daten.wunsch = 'auszahlung';
    if (!daten.wunsch) f('wunsch', 'Bitte wähle, wie du dein Geld möchtest.');
    if (!daten.vorname || !daten.nachname) f('name', 'Bitte gib deinen Vor- und Nachnamen an.');
    if (!/^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/.test(daten.email)) f('email', 'Bitte gib eine gültige E-Mail-Adresse an.');
    if (daten.telefon.replace(/\D/g, '').length < 6) f('telefon', 'Bitte gib deine Telefonnummer an.');
    if (!/^\d{4,5}$/.test(daten.plz)) f('plz', 'Bitte gib deine Postleitzahl an.');
    if (!daten.datenschutz) f('datenschutz', 'Bitte bestätige, dass wir dich kontaktieren dürfen.');
    if (!ok) { ersterFehlerZeigen(kontakt); return; }
    var knopf = kontakt.querySelector('[type=submit]');
    knopf.disabled = true; knopf.textContent = 'Wird gesendet …';
    senden('/anfrage', daten).then(function (d) {
      ergebnis.hidden = true;
      danke.hidden = false;
      $('[data-ak-vorgang]').textContent = d.anfrage;
      $('[data-ak-bestaetigung-an]').textContent = daten.email;
      $('[data-ak-bestaetigung]').hidden = false;
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      danke.focus({ preventScroll: true });
    }).catch(function (err) {
      if (err.feld && err.feld !== 'id') { fehler(err.feld, err.message, kontakt); ersterFehlerZeigen(kontakt); }
      else fehler('kontakt-global', err.message, kontakt);
    }).then(function () { knopf.disabled = false; knopf.textContent = 'Ankauf anfragen'; });
  });

  boschAnpassen();
  gespeichertesAngebot();
})();
